import React from 'react';
import { Pencil, Trash } from '@phosphor-icons/react';
import { OverflowWrapper } from 'app/components';

export const COLUMN_CONFIG = [
  {
    'label': 'Event Name',
    'path': 'name',
    'order': 1,
    'field': 'name',
    rowElement: ({ row }) => (
      <div className="event-name flex gap-2 items-center">
        <img src={row?.image}
          width={40}
          height={40} />
        <OverflowWrapper>{row?.name}</OverflowWrapper>
      </div>
    ),
  },
  {
    'label': 'Artist',
    'path': 'artist_name',
    'order': 2,
    'field': 'artist_name',
  },
  {
    'label': 'City',
    'path': 'city',
    'order': 3,
    'field': 'city',
  },
  {
    'label': 'Date & Time',
    'path': 'start_date',
    'order': 4,
    isDate: true,
    'field': 'start_date',
  },
  {
    'label': 'Created',
    'path': 'createdAt',
    'order': 6,
    isDate: true,
    'field': 'createdAt',
  },
  {
    'label': 'Total Tickets',
    'path': 'totalTickets',
    'order': 7,
    'field': 'totalTickets',
  },
  {
    'label': 'Sold Tickets',
    'path': 'soldTickets',
    'order': 8,
    'field': 'soldTickets',
  },
  {
    'label': 'Status',
    'path': 'status',
    'order': 9,
    'field': 'status',
    rowElement: ({ row }) => (
      <div className={`${row?.is_active ? 'text-primary-green' : 'text-error'}`}>
        {row?.is_active ? 'Coming Up' : 'Expired'}
      </div>
    ),
  },
  {
    'label': '',
    'path': 'action_items',
    'order': 10,
    'field': 'action_items',
  },
];

export const ALL_CITIES_FILTER = [
  { id: '', label: 'All Cities' },
];

export const STATUS_FILTER = [
  { id: 'ALL', label: 'All' },
  { id: 'COMING UP', label: 'Coming Up' },
  { id: 'EXPIRED', label: 'Expired' },
];

export const ACTION_ITEMS = [
  { icon: <Pencil />, action: 'edit' },
  { icon: <Trash />, action: 'delete' },
];
